import React from 'react'
import './ui.css'

const SIZES = ['lg', 'md', 'sm']
const STATUSES = ['online', 'offline', 'away']

function Avatar ({
  size = 'md',
  status,
  children,
  className = '',
  title,
  ...props
}) {
  const s = SIZES.includes(size) ? size : 'md'
  return (
    <span
      className={`ds-avatar ds-avatar-${s} ${className}`.trim()}
      title={title}
      {...props}
    >
      {children}
      {STATUSES.includes(status) && (
        <span className={`ds-avatar-status ds-avatar-status-${status}`} aria-hidden />
      )}
    </span>
  )
}

export default Avatar
